// components/FieldMappingDialog.tsx
import { useState, useEffect } from 'react';

// Field Mapping Dialog Component
const FieldMappingDialog = ({ 
  isOpen, 
  onClose, 
  componentId, 
  componentName, 
  currentMappings, 
  availableFields, 
  onSave 
}: {
  isOpen: boolean;
  onClose: () => void;
  componentId: string;
  componentName: string;
  currentMappings: any;
  availableFields: string[];
  onSave: (componentId: string, mappings: any) => void;
}) => {
  const [mappings, setMappings] = useState(currentMappings);

  useEffect(() => {
    setMappings(currentMappings);
  }, [currentMappings]);

  const handleFieldChange = (fieldName: string, updates: any) => {
    setMappings((prev: any) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        fieldName,
        ...updates,
      },
    }));
  };

  const handleSave = () => {
    onSave(componentId, mappings);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">Field Mapping - {componentName}</h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded">
            ✕
          </button>
        </div>

        <div className="p-4 overflow-y-auto max-h-[60vh]">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2">Field Name</th>
                <th className="text-left py-2">Label</th>
                <th className="text-left py-2">Database Field</th>
                <th className="text-center py-2">Active</th>
              </tr>
            </thead>
            <tbody>
              {availableFields.map((field) => {
                const mapping = mappings[field] || {
                  fieldName: field,
                  label: field,
                  is_active: true,
                  parameter: '',
                };

                return (
                  <tr key={field} className="border-b">
                    <td className="py-2">{field}</td>
                    <td className="py-2">
                      <input
                        type="text"
                        value={mapping.label}
                        onChange={(e) => handleFieldChange(field, { label: e.target.value })}
                        className="w-full px-2 py-1 border rounded"
                      />
                    </td>
                    <td className="py-2">
                      <input
                        type="text"
                        value={mapping.parameter}
                        onChange={(e) => handleFieldChange(field, { parameter: e.target.value })}
                        placeholder="e.g., customer.name"
                        className="w-full px-2 py-1 border rounded"
                      />
                    </td>
                    <td className="text-center py-2">
                      <input
                        type="checkbox"
                        checked={mapping.is_active}
                        onChange={(e) => handleFieldChange(field, { is_active: e.target.checked })}
                        className="cursor-pointer"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="flex justify-end space-x-2 p-4 border-t">
          <button onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded">
            Cancel
          </button>
          <button onClick={handleSave} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
            Save Mappings
          </button>
        </div>
      </div>
    </div>
  );
};

export default FieldMappingDialog;